<template>
    <div>
        <!-- <b-alert :show="!!errorHandlingMessage" dismissible>{{ errorHandlingMessage }}</b-alert> -->
        <core-error-alerts :errors="errorMsgList"></core-error-alerts>

        <transition name="fade-fast" mode="out-in">
        
            <busy-spinner v-if="loading" key="loadingTrue" inner-class="my-4" text="Loading..."></busy-spinner>

            <div v-else key="loadingFalse">
                        
                <b-table
                    v-if="allLines.length"
                    key="hasBidLines"
                    :items="allLines"
                    :fields="tableFields"
                    small
                    hover
                    :tbody-tr-class="tbodyTrClass"
                    class="quotesheet-reply-data-table no-top-border td-align-middle small"
                >
                    <template #cell(name)="data">
                        <div v-if="data.item.isFirstVariant">
                            <div class="font-weight-bold">{{ data.item.name }}</div>
                            <!-- <div class="font-size-70 text-muted">{{ data.item.description }}</div> -->
                        </div>
                    </template>
                    <template #cell(description)="data">
                        <div v-if="data.item.isFirstVariant">
                            {{ data.item.description }}
                        </div>
                    </template>
                    <template #cell(part_number)="data">
                        <div v-if="data.item.isFirstVariant">
                            {{ data.item.part_number }}
                        </div>
                    </template>
                    <!-- <template #cell(variant_description)="data">
                        <div class="">{{ data.item.variant.description }}</div>
                    </template> -->
                    <template #cell(quantity_details)="data">
                        {{ data.item.quantity }} <span class="text-muted">{{data.item.uom}} {{data.item.timeframe}}</span>
                    </template>
                    <template #cell(price)="data">
                        <div v-if="data.item.nobid" key="nobid" class="text-muted">NO BID</div>
                        <div v-else key="hasBid">{{ data.value }}</div>
                    </template>

                </b-table>

                <!-- <pre>{{ allLines }}</pre> -->

            </div>

        </transition>

    </div>
</template>

<script>
//import { suppliosApi } from '../../js/api-service';
import { errorHandling } from '../../js/custom-vue-mixins';
//import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
import { 
    //FormatCurrencyHelper, 
    toNumberOrNull,
    //hasValueOrZero,
    FormatDateHelper,
} from '../../js/filters-helpers';
// import { 
//     vendorColsAll, 
//     genericBidPriceFormatter 
// } from './quote-sheet-vendor-cols';
// import cloneDeep from 'lodash/cloneDeep';


class QuoteSheetVariantLine {
    constructor({ id, item, variant, variantIndex }) {
        this.id = id;
        // this.reply_id = reply_id;
        // this.reply = reply;
        this.item = item;
        this.variant = variant;
        this.isFirstVariant = variantIndex === 0;  // May 19 2025 - changed to pass this in instead of inspecting sort_order -- it's not reliable
        // this.bid = bid;
    }
    // GETTERS
    get name() {
        return this.item.linked_product?.name || this.item.linked_product?.display_name || this.item.name; 
    }
    get part_number() {
        return this.item.linked_product?.part_number || this.item.part_number;
    }
    get description() {
        return this.item.description || this.item.linked_product?.description;
    }
    get variant_description() {
        return this.variant.description;
    }
    get quantity() {
        return toNumberOrNull(this.variant.quantity); 
    }
    get uom() {
        return this.variant.uom;
    }
    get timeframe() {
        return this.variant.quantity_timeframe;
    }
    get need_by_date() {
        // TODO - format with Luxon?
        return this.variant.need_by_date;
    }
    // get isFirstVariant() {  // require passing this in instead of inspecting sort_order -- it's not reliable
    //     // return true if this line is the first (or only) variant in the parent item
    //     // NOTE: checking if sort_order === 1 is unreliable!  because what if we started at 0 instead?
    //     return (this.variant.sort_order === 1);
    // }
}

const allTableFields = [  // put superset of table fields here
    {
        key: 'name',  // will include name, part_number, description
        label: 'Item',
        tdClass: '',
    },
    {
        key: 'part_number',  // we have a getter for this on the class for each row
        label: 'Part Number',
        tdClass: '',
    },
    {
        key: 'description',
        label: 'Item Description',
        tdClass: '',
    },
    {
        key: 'variant_description',
        label: 'Variant',
        tdClass: '',
    },
    {
        key: 'quantity_details',
        label: 'Quantity',
        tdClass: '',
    },
    // NOT SHOWING current_price / target_price to suppliers in any conditions for now
    // {
    //     key: 'current_price',
    //     label: 'Internal Current Price',
    //     thClass: ['max-width-120', 'text-center'],
    // },
    // {
    //     key: 'target_price',
    //     label: 'Internal Target Price',
    //     thClass: ['max-width-120', 'text-center'],
    // },
    {
        key: 'need_by_date',
        label: 'Need By Date',
        formatter: (value) => {
            return FormatDateHelper(value);
        },
    },
]

export default {
    name: 'QuoteSheetSupplierPreview',
    components: {},
    mixins: [
        errorHandling,
    ],
    props: {
        // rctdId: {
        //     type: [String],
        //     required: true,
        // },
        qsData: {
            type: Object,
            default: () => ({}),
        },
    },
    data: function() {
        return {
            loading: false,  
            allLines: [], // put here after building them all up
            tableFields: [],  // put here after filtering from api data
            visibleQuoteSheetFields: [],  // the keys that are visible -- we might have 'name', or 'part_number', or 'description' turned off
        }
    },
    computed: {

    },
    mounted: function() {
        //this.getData();
        //this.getMultipleReplies();
        this.setData();
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts error message array in this.errorMsgList
        // async getData() {  /// IMPLEMENT THIS LATER IF NEEDED, TO GET PREVIEW FOR EACH ONE SEPARATELY
        //     this.loading = true;
        //     let resp;
        //     try {
        //         resp = await suppliosApi.rfxCompanyToDo.get_external_preview_data(this.rctdId);
        //     } catch (error) {
        //         this.apiErrorHandler(error);
        //     }
        //     if (resp?.data) {
        //         this.qsData = resp.data.company_todo?.quotesheet;
        //         this.configureTable(qsData);
        //         this.buildRows(qsData);
        //     }
        //     this.loading = false;
        // },
        setData() {
            const qsData = this.qsData;
            this.configureTable(qsData);
            this.buildRows(qsData);
        },
        configureTable(qSheetData) {
            // construct stuff related to the table/grid
            let colsToShow = [];
            let itemFieldNames = qSheetData.item_field_names;
            this.visibleQuoteSheetFields = [...itemFieldNames];
            const removeFieldNames = [];
            if (itemFieldNames.includes('name')) {
                colsToShow.push('name');
            }
            if (itemFieldNames.includes('description')) {
                colsToShow.push('description');
            }
            if (itemFieldNames.includes('part_number')) {
                colsToShow.push('part_number');
            }
            const quantityFields = ['quantity', 'uom', 'quantity_timeframe'];
            const showQuantity = itemFieldNames.some(ifld => quantityFields.includes(ifld));
            if (showQuantity) {
                colsToShow.push('quantity_details');
            } 
            if (itemFieldNames.includes('current_price')) {
                colsToShow.push('current_price');
            } 
            if (itemFieldNames.includes('target_price')) {
                colsToShow.push('target_price');
            }
            if (itemFieldNames.includes('need_by_date')) {
                colsToShow.push('need_by_date');
            }
            // TODO - add something here about showing variant details
            let hasMultipleVariants = Boolean(qSheetData.quotesheet_items.map(qsi => qsi.variants.length).filter(varCount => (varCount > 1)).length);  // make array of how many variants each item has, filter for any with more than one, are there any?
            if (hasMultipleVariants) {
                colsToShow.push('variant_description');
            }
            let has_multiple_quoted_currency_options = qSheetData.has_multiple_quoted_currency_options ?? false;
            if (!has_multiple_quoted_currency_options) {
                // if not multi-currency, don't show multiple price / subtotal cols
                removeFieldNames.push('quoted_price', 'quoted_subtotal')
            }
            let enabledFieldNames = qSheetData.enabled_field_names.filter(fn => !removeFieldNames.includes(fn));
            let allFieldNames = colsToShow.concat(enabledFieldNames);
            this.tableFields = allTableFields.filter(tfld => allFieldNames.includes(tfld.key));
            console.log(this.tableFields);
        },
        buildVariantLines(qs_items) {
            // build a single array of variants, with parent quotesheet_item/linked_product along-side it
            // this un-nests the variants from qs_items
            // don't worry about cloning all qs_items and linked_products as you put them in... since this is not for editing
            let variantLines = [];  // fill this up
            qs_items.forEach(item => {
                let itemKeysToPick = ['id', 'name', 'part_number', 'description', 'sort_order', 'linked_product'];
                let itemOnly = pick(item, itemKeysToPick);
                item.variants.forEach((variant, idx) => {
                    let varLine = {};  // the new object we'll return list of 
                    varLine['id'] = variant.id;
                    varLine['variant_id'] = variant.id;  // make it easy to pull this out when we make composite key for bidLines
                    varLine['variant'] = {...variant};
                    varLine['variantIndex'] = idx;  // add this to help with knowing if first or not... more reliable than sort_order
                    varLine['item'] = itemOnly;
                    variantLines.push(varLine);
                });
            });
            return variantLines;  // use this to further build up lines for each bid
        },
        buildRows(qSheetData) {
            // build all the rows of the grid
            // qSheetData is dict of the QuoteSheet from api
            let variantLines = this.buildVariantLines(qSheetData.quotesheet_items);
            //let allLines = repliesList.flatMap(reply => this.buildBidLinesForReply(variantLines, reply));
            this.allLines = variantLines.map(l => new QuoteSheetVariantLine(l));
            console.log(this.allLines);
        },
        tbodyTrClass: function(item, type) {
            // item is the row item, 
            // type is 'row' for item row, 'row-details' for item details row, 'row-top' for fixed top row slot, 'row-bottom' for fixed bottom row slot, 'table-busy' for table busy slot
            // should return array, object, or string
            if (type !== 'row') {
                return '';
            }
            return item.isFirstVariant ? 'first-variant' : 'not-first-variant'; // just add this, then style <td> inside via CSS
        }
    }
}
</script>

<style lang="scss">

.quotesheet-reply-data-table {
    border-color: var(--gray-100);
    tr.first-variant {
        td {
            border-top: 1px solid var(--gray-500);
        }
    }
}

</style>